import { getAssets } from "@unisearch/helpers";
import Image from "next/legacy/image";
import Link from "next/link";
import React from "react";
import { GrLinkedinOption } from "react-icons/gr";
import styles from "./member.module.scss";

const TeamMemberCard = ({ data }) => {
  const linkinData = data?.socialMediaLinks?.find(
    (item) => item.name == "LinkedIn"
  );

  return (
    <div
      className={`relative ${styles.team_card} ${
        !data?.showInDetailsPage ? styles.member_disabled : ""
      }`}
    >
      {!data?.showInDetailsPage && (
        <div className={`${styles.overlay_wrapper}`}>
          <span className="uni-tooltip">Unavailable at this time</span>
        </div>
      )}
      <Link
        className={styles.team_card_head}
        href={`/team/details/${data?.uuid}?cat=${data?.categorySlug}` || "#"}
      >
        <Image
          layout="responsive"
          width={370}
          height={370}
          blurDataURL={getAssets(
            "assets/images/study/country_placeholder.webp"
          )}
          placeholder="blur"
          src={
            data?.profileImageSrc || getAssets("assets/student-avatar-big.png")
          }
          alt={`${data?.firstName} ${data?.middleName} ${data?.lastName}`}
        />
      </Link>

      <div className={styles.team_card_body}>
        <div>
          <Link
            href={
              `/team/details/${data?.uuid}?cat=${data?.categorySlug}` || "#"
            }
          >
            <h4
              className={styles.team_card_name}
            >{`${data?.firstName} ${data?.middleName} ${data?.lastName}`}</h4>
          </Link>

          {data?.designationName && (
            <Link
              href={
                `/team/details/${data?.uuid}?cat=${data?.categorySlug}` || "#"
              }
            >
              <div className={styles.team_card_designation}>
                {data?.designationName}
              </div>
            </Link>
          )}
        </div>
        {linkinData && (
          <a
            className={styles.team_card_social}
            rel="nofollow"
            target="_blank"
            href={linkinData?.link}
          >
            <GrLinkedinOption />
          </a>
        )}
      </div>
    </div>
  );
};

export default TeamMemberCard;
